import React, { useState, useEffect } from 'react';
import { ArrowDownRight, ArrowUpRight, Download, Loader } from 'lucide-react';

const Transactions = ({ userData }: { userData?: any }) => {
  const [filter, setFilter] = useState('All');
  const [transactions, setTransactions] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  // BACKEND SE LIVE TRANSACTIONS LAA RAHA HAI
  useEffect(() => {
    if (userData && userData.id) {
      fetch(`https://motilalalgo.com/api/profile/${userData.id}/transactions`)
        .then(res => res.json())
        .then(data => {
          setTransactions(data);
          setLoading(false);
        })
        .catch(err => {
          console.error("Failed to fetch transactions:", err);
          setLoading(false);
        });
    }
  }, [userData]);

  if (loading) {
    return <div className="h-full flex items-center justify-center text-blue-500"><Loader className="animate-spin" size={40} /></div>;
  }

  return (
    <div className="max-w-5xl mx-auto space-y-8">
      <div className="flex justify-between items-end">
        <div>
          <h1 className="text-3xl font-bold text-white">Transactions</h1>
          <p className="text-gray-400 mt-1">View your complete account statement.</p>
        </div>
        <button className="flex items-center gap-2 bg-[#1e222d] border border-gray-700 text-white px-4 py-2 rounded-lg text-sm hover:bg-[#2a2e39] transition-colors">
          <Download size={16} /> Download Statement
        </button>
      </div>

      <div className="bg-[#131b2c] border border-gray-800 rounded-2xl p-6 shadow-xl">
        {/* Filters */}
        <div className="flex gap-4 mb-6 border-b border-gray-800 pb-4 overflow-x-auto">
          {['All', 'Deposits', 'Withdrawals', 'Trades'].map((f) => (
            <button 
              key={f} 
              onClick={() => setFilter(f)}
              className={`px-4 py-2 rounded-full text-sm font-bold whitespace-nowrap transition-colors ${filter === f ? 'bg-blue-600 text-white' : 'bg-[#1e222d] text-gray-400 hover:text-white'}`}
            >
              {f}
            </button>
          ))}
        </div>

        {/* Transaction List */}
        <div className="space-y-4">
          {transactions.length > 0 ? (
            transactions.map((tx, idx) => (
              <div key={idx} className="flex items-center justify-between p-4 bg-[#0b1221] border border-gray-800 rounded-xl hover:border-gray-700 transition-colors">
                <div className="flex items-center gap-4">
                  <div className={`w-12 h-12 rounded-full flex items-center justify-center ${tx.type === 'DEPOSIT' ? 'bg-green-500/10 text-green-500' : tx.type === 'WITHDRAW' ? 'bg-red-500/10 text-red-500' : 'bg-blue-500/10 text-blue-500'}`}>
                    {tx.type === 'DEPOSIT' ? <ArrowDownRight size={24} /> : <ArrowUpRight size={24} />}
                  </div>
                  <div>
                    <p className="font-bold text-white">{tx.type === 'BUY' ? `Bought ${tx.asset}` : tx.type}</p>
                   <p className="text-xs text-gray-500 font-mono">ID: {tx.trx_id} • {new Date(tx.created_at).toLocaleString()}</p>
                  </div>
                </div>
                <div className="text-right">
                  <p className={`font-bold text-lg ${tx.type === 'DEPOSIT' ? 'text-green-500' : 'text-white'}`}>
                    {tx.type === 'DEPOSIT' ? '+' : '-'}₹{parseFloat(tx.amount).toFixed(2)}
                  </p>
                  <p className={`text-xs font-bold ${tx.status === 'Success' ? 'text-green-500' : 'text-orange-500'}`}>{tx.status}</p>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-10 text-gray-500">
              No transactions found.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Transactions;